import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 12l-4.97-7H8.66l10.7 10.73zM2 4l1 1v14h14l2 2 1.41-1.41L3.44 2.62z"
}), 'LabelOffSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LabelOffSharp.js
// module id = 4384
// module chunks = 2